
import React, { useEffect, useState } from 'react';
import dynamic from 'next/dynamic';
import { CircularProgress, Grid } from '@material-ui/core';
import AdditionalActions from '../components/Dashboards/AdditionalActions';
import { EventsSection } from '../components/Dashboards/UpcommingEvents';
import { QAWidget } from '../components/Dashboards/AllQAIssues';

import Title from '../components/Title';
import { instance as axios } from '../utils/axios-config';

const TableauSection = dynamic(() => import('../components/Tableau/TableauSection'), {
  ssr: false,
  loading: () => <CircularProgress />,
});
const Dashboards = ({ user: { tableau: tableauUser } }) => {

  const [events, setEvents] = useState(null);
  const [qaIssues, setqaIssues] = useState(null);

  useEffect(() => {
    const getIssues = async () => {
      const { data } = await axios('/Entry', {
        params: {
          retainFormData: true,
          itemsPerPage: 1000,
          entryStatus: 'QA Issue'
        }
      });
      if (data) {
        const issueEntries = data
          .filter((entry) => entry.issues.length > 0)
          .map((e) => {
            const formData = JSON.parse(e.form.data);
            return { ...e, formTitle: formData.title };
          });
        setqaIssues({ data: issueEntries });
      }
    };
    getIssues();

    const getEvents = async () => {
      const { data } = await axios('/Entry/UpcomingEntries');
      setEvents({ data });
    };
    getEvents();
  }, []);

  return (
    <>
      <Grid container className='surgeonDashboard'>
        <Title>{'Dashboard'}</Title>
        {tableauUser && <TableauSection />}

        {qaIssues ? <QAWidget data={qaIssues.data} /> : <CircularProgress />}
        {events ? <EventsSection data={events.data} /> : <CircularProgress />}
        <AdditionalActions />
      </Grid>
    </>
  );
};

export default Dashboards;
